/**
 * Represent the types of sources to handle in the Paste Plugin
 */
export const enum KnownPasteSourceType {
    WordDesktop,
    ExcelDesktop,
    ExcelOnline,
    PowerPointDesktop,
    GoogleSheets,
    WacComponents,
    Default,
    SingleImage,
}
